import { HoneycombWebSDK } from '@honeycombio/opentelemetry-web';
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';

const getInitialUser = () => {
  try {
    const appElement = document.getElementById('app');
    if (!appElement || !appElement.dataset.page) {
      return null;
    }
    const page = JSON.parse(appElement.dataset.page);
    return page.props.auth?.user;
  } catch {
    return null;
  }
};

const user = getInitialUser();

if (import.meta.env.VITE_OTEL_ENABLED === 'true') {
  const sdk = new HoneycombWebSDK({
    // Point to YOUR server's collector, NOT Honeycomb directly
    // This hides your Honeycomb API key from the public
    endpoint:
      import.meta.env.VITE_OTEL_EXPORTER_OTLP_ENDPOINT ||
      'https://app.factoryqa.com/v1/traces',
    serviceName: import.meta.env.VITE_OTEL_SERVICE_NAME || 'factoryqa-frontend',
    instrumentations: [getWebAutoInstrumentations()],
    ...(user
      ? {
          resourceAttributes: {
            'app.user_id': user.id,
            'app.company_id': user.company_id,
          },
        }
      : {}),
  });

  sdk.start();
}
